module.exports = __webpack_public_path__ + "img/Deaminasevariants_C.524f241d.svg";